import classnames from 'classnames';
import { memo } from 'preact/compat';

import ServiceLogo from './ServiceLogo';
import { useSbr, useWidgetContext } from '../../hooks';

function Service() {
	const {
		props: { service }
	} = useWidgetContext();
	const sbrUser = useSbr();
	const { id, href, logo, icon, sbr } = service;

	return (
		<a
			className={classnames({
				'ribbon-service': true,
				'ribbon-service--sbr': sbr && sbrUser
			})}
			href={href || '/'}
			data-dot={`lista_${id}`}
			data-e2e='ribbon-service'
		>
			<ServiceLogo
				iconSrc={icon?.src}
				iconLabel={`${sbr && sbrUser ? 'Bez reklam' : icon?.label}`}
				logoSrc={logo.src}
				logoHeight={logo.height}
			/>
		</a>
	);
}

export { Service };
export default memo(Service);
